import { render, staticRenderFns } from "./30.vue?vue&type=template&id=c5180fec&"
import script from "./30.vue?vue&type=script&lang=js&"
export * from "./30.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports